/* Header: mobile menu, dropdown submenus, search panel and basket count.
   Every listener is tied to one AbortController, so a Theme Editor reload leaves nothing behind. */
LYM.section('header', function (root) {
  var ac = new AbortController();
  var opts = { signal: ac.signal };
  var mq = window.matchMedia('(max-width: 900px)');

  var menuBtn = root.querySelector('[data-menu-toggle]');
  var nav = root.querySelector('[data-nav]');
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-nav-item]'));
  var searchToggle = root.querySelector('[data-search-toggle]');
  var searchPanel = root.querySelector('[data-search-panel]');
  var searchInput = root.querySelector('[data-search-input]');

  function setMenu(open) {
    if (!menuBtn || !nav) return;
    nav.classList.toggle('is-open', open);
    menuBtn.setAttribute('aria-expanded', String(open));
  }

  function setSub(item, open) {
    var btn = item.querySelector('[data-sub-toggle]');
    item.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', String(open));
  }

  function setSearch(open) {
    if (!searchToggle || !searchPanel) return;
    searchPanel.hidden = !open;
    searchToggle.setAttribute('aria-expanded', String(open));
  }

  function closeAll(except) {
    items.forEach(function (item) { if (item !== except) setSub(item, false); });
    if (except !== 'menu') setMenu(false);
    if (except !== 'search') setSearch(false);
  }

  if (menuBtn) {
    menuBtn.addEventListener('click', function () {
      var open = menuBtn.getAttribute('aria-expanded') !== 'true';
      closeAll('menu');
      setMenu(open);
    }, opts);
  }

  items.forEach(function (item) {
    var btn = item.querySelector('[data-sub-toggle]');
    if (btn) {
      btn.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        closeAll(item);
        item.removeAttribute('data-dismissed');
        setSub(item, open);
      }, opts);
    }
    item.addEventListener('mouseleave', function () { item.removeAttribute('data-dismissed'); }, opts);
  });

  if (searchToggle && searchPanel) {
    // Without JavaScript this is a normal link to the search page. With it, the link opens the panel.
    searchToggle.setAttribute('role', 'button');
    searchToggle.setAttribute('aria-expanded', 'false');
    searchToggle.addEventListener('click', function (e) {
      e.preventDefault();
      var open = searchToggle.getAttribute('aria-expanded') !== 'true';
      closeAll('search');
      setSearch(open);
      if (open && searchInput) searchInput.focus();
    }, opts);
  }

  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openItem = items.filter(function (i) { return i.classList.contains('is-open'); })[0];
    var hoverItem = items.filter(function (i) { return i.matches(':hover'); })[0];
    if (searchPanel && !searchPanel.hidden) { setSearch(false); searchToggle.focus(); }
    else if (nav && nav.classList.contains('is-open')) { setMenu(false); menuBtn.focus(); }
    else if (openItem) {
      setSub(openItem, false);
      if (openItem.matches(':hover')) openItem.setAttribute('data-dismissed', '');
      var b = openItem.querySelector('[data-sub-toggle]'); if (b) b.focus();
    }
    else if (hoverItem) { hoverItem.setAttribute('data-dismissed', ''); }
  }, opts);

  // Close when focus moves out of the header, or a click lands outside it.
  root.addEventListener('focusout', function (e) {
    if (e.relatedTarget && !root.contains(e.relatedTarget)) closeAll();
  }, opts);
  document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeAll(); }, opts);

  // Leaving the mobile layout resets the menu.
  if (mq.addEventListener) mq.addEventListener('change', function () { closeAll(); }, opts);

  // If the desktop menu does not fit on one line, switch to the compact menu at any width.
  var row = root.querySelector('.site-header__row');
  var actions = root.querySelector('.site-header__actions');
  var wide = window.matchMedia('(min-width: 1101px)');
  function fitMenu() {
    if (!row || !nav || !actions) return;
    var wasCompact = root.classList.contains('is-compact');
    root.classList.remove('is-compact');
    if (wide.matches) {
      var parts = [row.firstElementChild, nav, actions];
      var tops = parts.map(function (el) { return el.getBoundingClientRect().top; });
      var wrapped = Math.max.apply(null, tops) - Math.min.apply(null, tops) > 24 || row.scrollWidth > row.clientWidth + 1;
      if (wrapped) root.classList.add('is-compact');
    }
    if (wasCompact !== root.classList.contains('is-compact')) closeAll();
  }
  var fitTimer = LYM.debounce(fitMenu, 100);
  window.addEventListener('resize', fitTimer, opts);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitMenu);
  fitMenu();

  // Live basket count. The cart drawer and cart page send `cart:updated` with { item_count }.
  var counts = Array.prototype.slice.call(root.querySelectorAll('[data-cart-count]'));
  document.addEventListener('cart:updated', function (e) {
    var n = e && e.detail && typeof e.detail.item_count === 'number' ? e.detail.item_count : null;
    if (n === null) return;
    counts.forEach(function (el) { el.textContent = '(' + n + ')'; });
    fitMenu();
  }, opts);

  return function destroy() { ac.abort(); };
});
